import { OverallConnectionType } from '../../../../Quotes/types/connectionType';
import { ProductType } from '../../../../Quotes/types/productTypes';
import Column from '../../../../shared/components/atoms/Column';
import React from 'react';
import Cost from './Cost';

export function AEndPortCosts(props: {
  connectionType: OverallConnectionType;
  productType: ProductType;
  aEndPortCost: {
    annual: number | undefined;
    install: number | undefined;
    description: string | null | undefined;
  } | null;
  aEndOpticalCosts?: { install: number | undefined; annual: number | undefined };
}) {
  return (
    <div>
      {props.connectionType === 'Ethernet' && props.productType !== ProductType.OpticalP2P && (
        <div className="row no-gutters mt-1">
          <Column defaultWidth={2} offsetDefaultWidth={2}>
            <span>Port</span>
          </Column>
          <Cost label="Install" cost={props.aEndPortCost?.install ?? 0} className="port-a-install" />
          <Cost label="Annual" cost={props.aEndPortCost?.annual ?? 0} className="port-a-annual" />
        </div>
      )}
      {props.productType === ProductType.OpticalP2P && (
        <div className="row no-gutters mt-1">
          <Column defaultWidth={2} offsetDefaultWidth={2}>
            <span>Port</span>
          </Column>
          <Cost label="Install" cost={props.aEndOpticalCosts?.install ?? 0} className="port-a-install" />
          <Cost label="Annual" cost={props.aEndOpticalCosts?.annual ?? 0} className="port-a-annual" />
        </div>
      )}
    </div>
  );
}
